'use strict';
import * as _ from 'lodash';

export class DateRecordEditDialogModel {
  constructor(config, data, editMode) {
    this.modalService = null;
    this.date = null;
    this.dateString = null;
  }

  init(modal, scope, modalService) {
    this.modalInstance = modal;
    this.modalService = modalService;
  }

  _hasChanged() {
    return false;
  }

  getDateString(date){
    var day = date.getDate().toString();
    var month = (date.getMonth() + 1 ).toString();
    var year = date.getFullYear().toString();
    return month + '/' + day + '/' + year;
  }

  save() {    
    if(this.date instanceof Date){
      this.dateString = this.getDateString(this.date);
    }
    this.modalInstance.remove();
  }

  async closeWindow() {
    if (this._hasChanged()) {
      const confirmed = await this.modalService.showConfirmation(null, 'You have unsaved changes. Are you sure you want to cancel?')
      if (confirmed) {
        this.cancelled = true;
        this.modalInstance.remove();
      }
      return;
    }
    this.cancelled = true;
    this.modalInstance.remove();
  };

  close() {
    this.cancelled = true;
    this.modalInstance.remove();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/models/dateRecordEdit.js